'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { watchForI18nReady as watchForI18nReadyAction } from 'ContentEditorUI/redux/actions/i18n';
import { removeBaymaxSkeleton, removeEarlyIframeWrappers, removePatagoniaSkeleton } from 'ContentEditorUI/lib/layoutDom';
const mapDispatchToProps = {
  watchForI18nReady: watchForI18nReadyAction
};
class ErrorPagePortal extends Component {
  componentDidMount() {
    const {
      watchForI18nReady
    } = this.props;
    // Make sure that we still set I18n ready so the error page renders (since ApplicationContainer
    // that normally does it isn't being rendered)
    watchForI18nReady();

    // Remove skeleton and static early iframes if an app/ error is shown before the first real render
    removeBaymaxSkeleton();
    removePatagoniaSkeleton();
    removeEarlyIframeWrappers();
  }
  render() {
    const {
      children
    } = this.props;

    // Portal render the full page error into the right (higher-level) place in our static HTML
    return /*#__PURE__*/ReactDOM.createPortal(children, document.querySelector('.page'));
  }
}
ErrorPagePortal.propTypes = {
  children: PropTypes.node.isRequired,
  watchForI18nReady: PropTypes.func.isRequired
};
export default connect(undefined, mapDispatchToProps)(ErrorPagePortal);